import request from '@/utils/request'

export function listPayinBonus(data) {
  return request({
    url: '/api/v1/admin/payment/payin/bonus/list',
    method: 'post',
    mock: false,
    data,
  })
}

export function getPayinBonus(data) {
  return request({
    url: '/api/v1/admin/payment/payin/bonus/get',
    method: 'post',
    mock: false,
    data,
  })
}

export function createPayinBonus(data) {
  return request({
    url: '/api/v1/admin/payment/payin/bonus/create',
    method: 'post',
    mock: false,
    data,
  })
}

export function updatePayinBonus(data) {
  return request({
    url: '/api/v1/admin/payment/payin/bonus/update',
    method: 'post',
    mock: false,
    data,
  })
}

export function deletePayinBonus(data) {
  return request({
    url: '/api/v1/admin/payment/payin/bonus/delete',
    method: 'post',
    mock: false,
    data,
  })
}
///api/v1/admin/payment/payin/bonus/multiple
export function setPayinBonusMultiple(data) {
  return request({
    url: '/api/v1/admin/payment/payin/bonus/multiple',
    method: 'post',
    mock: false,
    data,
  })
}
